import { ColDef } from '@ag-grid-community/core';
import {
  entityComparator,
  caseInsensitiveComparator,
} from "utils/aggrid";
import { AgGridCellRendererTags } from "components/common/AgGridCellRendererTags";
import { Tag } from "interfaces/tags";

export const getColumnDefs = (): Array<ColDef> => ([
  {
    field: 'id',
    headerName: 'Id',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    cellRenderer: () => null,
    maxWidth: 70,
    pinned: true,
  },
  {
    field: 'name',
    headerName: 'Customer Name',
    sortable: true,
    resizable: true,
    flex: 1,
    minWidth: 250,
    comparator: caseInsensitiveComparator(),
  },
  {
    field: 'tags',
    headerName: 'Tags',
    sortable: true,
    resizable: true,
    flex: 1,
    minWidth: 250,
    comparator: entityComparator,
    cellRenderer: AgGridCellRendererTags,
    getQuickFilterText: ({ value }) => value?.map((tag: Tag) => tag.name),
  },
  {
    field: 'crmId',
    headerName: 'CRM ID',
    sortable: true,
    resizable: true,
    flex: 1,
    minWidth: 250,
    valueFormatter: ({ value }) => value ? value : '-',
  },
]);